/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Endpoint_Try_Missing_PlaceholderInputs */

const en_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What is missing from ${i?.name}? Name the field or the source.`)
};

const zh_hans1_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}缺少什么？请写出字段或数据源。`)
};

const pt_br2_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O que está faltando em ${i?.name}? Diga o campo ou a fonte.`)
};

const es_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué le falta a ${i?.name}? Indica el campo o la fuente.`)
};

const fr_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que manque-t-il à ${i?.name} ? Nommez le champ ou la source.`)
};

const de_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was fehlt bei ${i?.name}? Nenne das Feld oder die Quelle.`)
};

const ru_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Чего не хватает в ${i?.name}? Назовите поле или источник.`)
};

const it_endpoint_try_missing_placeholder = /** @type {(inputs: Endpoint_Try_Missing_PlaceholderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cosa manca a ${i?.name}? Indica il campo o la fonte.`)
};

/**
* | output |
* | --- |
* | "What is missing from {name}? Name the field or the source." |
*
* @param {Endpoint_Try_Missing_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_missing_placeholder = /** @type {((inputs: Endpoint_Try_Missing_PlaceholderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_Missing_PlaceholderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_missing_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_missing_placeholder(inputs)
	if (locale === "es") return es_endpoint_try_missing_placeholder(inputs)
	if (locale === "fr") return fr_endpoint_try_missing_placeholder(inputs)
	if (locale === "de") return de_endpoint_try_missing_placeholder(inputs)
	if (locale === "ru") return ru_endpoint_try_missing_placeholder(inputs)
	if (locale === "it") return it_endpoint_try_missing_placeholder(inputs)
	return en_endpoint_try_missing_placeholder(inputs)
});